import { render, staticRenderFns } from "./WorldViewEditPage.vue?vue&type=template&id=82e774ae&scoped=true"
import script from "./WorldViewEditPage.vue?vue&type=script&lang=ts"
export * from "./WorldViewEditPage.vue?vue&type=script&lang=ts"
import style0 from "./WorldViewEditPage.vue?vue&type=style&index=0&id=82e774ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e774ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82e774ae')) {
      api.createRecord('82e774ae', component.options)
    } else {
      api.reload('82e774ae', component.options)
    }
    module.hot.accept("./WorldViewEditPage.vue?vue&type=template&id=82e774ae&scoped=true", function () {
      api.rerender('82e774ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/WorldViewEditPage.vue"
export default component.exports